<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
          <div style="width:100%">
            <div class="card mt-2">
              <div class="card-body">
                
                <!-- TOMBOL -->
                <div class="row mb-2">
                  <div class="col-md-10">
                    <router-link v-show="false" :to="{ name: 'pelanggan-tambah'}"  class="btn btn-primary">Tambah Pelanggan</router-link>
                    <button @click="cariTelepon" class="btn btn-info">Cari Pelanggan</button>
                    <button @click="showArea()" class="btn btn-info">Filter Area</button>
                    <button @click="showPaket()" class="btn btn-info">Filter By Paket</button>
                    <button v-if="RootOnly()" class="btn btn-danger" @click="isOnDelete = true">Hapus Beberapa</button>
                  </div>
                  <div class="col-md-2 text-right" v-show="pageStat == 999">

                    <download-excel
                        style = "padding: 0"
                        :data   = "json_datapelanggan"
                        :fields = "json_fieldspelanggan"
                        worksheet = "My Worksheet"
                        :before-generate = "startDownload"
                        :title = "judulDoc"
                        :name    = "nameDoc">
                    
                      <button type="button" class="btn btn-primary">EXPORT</button>
                    </download-excel>

                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 cariByTanggal" v-show="cariByTelepon">
                    <div class="form-group">
                      <input type="text" class="form-control" placeholder="Cari..." style="width:100%" v-model="telepon" />
                    </div>
                  </div>
                  <div class="col-md-2 cariByTanggal" v-show="cariByTelepon">
                      <div class="form-group">
                      <button  class="btn btn-primary" @click="cariTeleponApi()">Cari</button>
                    </div>
                  </div>
                </div>
                <!-- END TOMBOL -->
                <div class="table-responsive">
                  <table class="table">
                    <thead class=" text-info">
                      <th>No.</th>
                      <th>Nama</th>
                      <th>PPOE</th>
                      <th>Paket</th>
                      <th>Area</th>
                      <th>Biaya</th>
                      <th>Tgl Register</th>
                      <th v-if="isOnDelete == false"></th>
                      <th v-else class="text-center">
                        Pilih 
                        <button v-if="DeleteSelect.length != 0" class="btn btn-sm btn-info" @click="hapusMulti()">Hapus</button>
                      </th>
                    </thead>
                    <tbody v-show="loading">
                      <tr>
                        <td colspan="8"><Loading></Loading></td>
                      </tr>
                      <tr>
                        <td colspan="8"><Loading></Loading></td>
                      </tr>
                      <tr>
                        <td colspan="8"><Loading></Loading></td>
                      </tr>
                    </tbody>
                    
                    <tbody v-show="pelanggan.length == 0">
                      <tr v-show="!loading">
                        <td></td>
                        <td>Tidak ada Data '{{kosongText}}'</td>
                      </tr>
                    </tbody>
                    <tbody v-show="!loading">
                      <tr v-for="(u, index) in pelanggan">
                        <td>{{ index+1 }}</td>
                        <td>
                          <strong class="h4 text-info">
                            <router-link :to="{ name: 'pelanggan-detail', params: { id:u.user.uid, user: u.user, area: u.area}}"   class="text-info" >( {{prefix + "" + u.user.fake_id}} )  {{ u.user.unama }}
                            </router-link></strong></br>
                            {{ u.user.wa }}</br>
                            <i class="material-icons text-info" style="font-size: 12pt;" v-if="u.user.mikrotik_id !=null">router</i>
                            <i class="material-icons text-warning" style="font-size: 12pt;" v-if="u.user.lat !=null">location_on</i>
                        </td>
                        <td><span class="text-info">{{ u.user.ppoe }}</span></br>{{ u.user.modem_info }}</td>
                        <td>{{ u.user.pnama }}</br><span class="text-secondary">Tagihan Tgl</span> {{ u.user.tanggal_tagihan }}</td>
                        <td>{{ u.area }}</td>
                        <td>
                          {{ ribu( ( ( parseInt(u.user.ptarif) + parseInt(isNull(u.user.biaya_tambahan)) + parseInt(isNull(u.user.biaya_tambahan_2)) ) + (  ( parseInt(u.user.ptarif) / 100 ) ) * parseInt(ppn)   ) - parseInt(isNull(u.user.diskon)) ) }} <i class="tombol material-icons text-info" @mouseover="infoShow = index" @mouseleave="infoShow = -1">error</i> 
                          <span class="info" v-if="infoShow == index" v-show="infoShow == index">
                            <p class="mb-0">PPN {{ppn}}% : {{ribu(parseInt(ppn) * ( parseInt(u.user.ptarif) / 100 ) )}}</p>
                            <p v-if="u.user.biaya_rincian != null" class="mb-0">{{u.user.biaya_rincian}} : {{ribu(u.user.biaya_tambahan) }}</p>
                            <p v-if="u.user.biaya_rincian_2 != null" class="mb-0">{{u.user.biaya_rincian_2}} : {{ribu(u.user.biaya_tambahan_2) }}</p>
                            <p class="mb-0">Diskon : {{ribu(isNull(u.user.diskon)) }}</p>
                          </span>
                        </td>
                        <td>{{ tglIndo(u.user.tanggal_register) }}</td>
                        <td class="text-center" :for="u.user.uid">
                          <span v-if="isOnDelete == false">
                             
                            <router-link :to="{ name: 'pelanggan-detail', params: { id:u.user.uid, user: u.user, area: u.area}}"   class="btn btn-sm btn-info" ><i class="material-icons">remove_red_eye</i></router-link>
                            <!-- EDIT -->
                            <router-link v-if="RootOnly()" :to="{ name: 'pelanggan-edit', params: { id: u.user.uid, nama:u.user.unama, wa:u.user.wa, tgl:u.user.tanggal_tagihan, paket:u.user.pnama, paketid:u.user.paket_id, bayar:u.user.ptarif, area:u.area, areaid:u.areaId, ppoe:u.user.ppoe, rincian1:u.user.biaya_rincian, rincian2:u.user.biaya_rincian_2, biaya1:u.user.biaya_tambahan, biaya2:u.user.biaya_tambahan_2, diskon:u.user.diskon, mikrotikId:u.user.mikrotik_id, lat:u.user.lat, lng:u.user.lng, tanggal_register:u.user.tanggal_register, alamat:u.user.alamat, modem_info:u.user.modem_info  }}"   class="btn btn-sm btn-secondary" ><i class="material-icons">edit</i></router-link>

                            <button v-show="RootOnly()" @click="modalHapus = true, idHapus = u.user.uid, nmHapus = u.user.unama" class="btn btn-sm btn-danger" ><i class="material-icons">delete_outline</i></button>

                          </span>

                          <input v-else style="height: 17px;width: 17px;" type="checkbox" class="form-group text-center p-1" :value="u.user.uid" v-model="DeleteSelect">

                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="card-footer " v-show="!loading">
                <div class="d-block" style="width:100%">
                  <div class="text-center" style="width:100%">
                    <button class="btn btn-info" @click="loadMore()" v-show="pageStat != 999">Load More {{pageLimit}}+</button>
                    <!-- <button class="btn btn-success" @click="loadAll(); pageStat = 999" v-show="pageStat != 999">Load All</button> -->
                  </div>
                  <div class="text-center" style="width:100%">
                    <span>Nyari Load All ya? di tiadakan dulu ya, tapi tiap loadmore udah {{pageLimit}} pelanggan kok :)</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
      </div>      
      
      
      <!-- MODAL -->
			<div class="modal" tabindex="-1" role="dialog" v-show="modalWA">
				<div class="overlay"></div>
				<div class="modal-dialog" role="document">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title">Progress WA c</h5>
						</div>
						<div class="modal-body">
              <div class="text-center">
                <p class="text-info">{{pesanKirimPause}}</p>
                <h2 class="mb-0">{{progress}} / <small><small>{{totalProgress}}</small></small></h2>
                <p>{{pesanKirim}}</p>
                
                <p class="text-warning">Jangan tutup Popup Ini, untuk melihat progress pengiriman pesan</p>
              </div>
						</div>
						<div class="modal-footer" v-show="modalWAFooter">
              <button class="btn btn-success" @click="modalWA = false"> Tutup</button>
					  </div>
					</div>
				</div>
			</div>  
      
      
      <!-- MODAL -->
			<div class="modal" tabindex="-1" role="dialog" v-show="modalWAPasswordProgress">
				<div class="overlay"></div>
				<div class="modal-dialog" role="document">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title">Progress WA b</h5>
						</div>
						<div class="modal-body">
              <div class="text-center">
                <p class="text-info">{{pesanKirimPause}}</p>
                <h2 class="mb-0">{{progress}} / <small><small>{{totalProgress}}</small></small></h2>
                <p>{{pesanKirim}}</p>
                
                <p class="text-warning">Jangan tutup Popup Ini, untuk melihat progress pengiriman pesan</p>
              </div>
						</div>
						<div class="modal-footer" v-show="modalWAPasswordFooter">
              <button class="btn btn-success" @click="modalWAPasswordProgress = false"> Tutup</button>
					  </div>
					</div>
				</div>
			</div>
      
			<!-- MODAL -->
      <div class="modal" tabindex="-1" role="dialog" v-show="modalWAPassword">
        <div class="overlay"></div>
        <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Format WA Pesan</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="modalWAPassword = false">
                <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body" style="overflow:auto;height: 450px;">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                        <div class="form-group">
                          <p class="text-info" style="margin:0">Format WA: </p>
                          <textarea rows="10" type="text" class="form-control" style="font-size: 10pt" placeholder="Nama Area..." v-model="waPassDisplay" readonly></textarea>
                          <label for="" class="bmd-label-floating mt-4">Nama App <span class="text-danger">(Opsional, Bila anda sudah berlanggan custom app pelanggan)</span></label>
                          <small text="text-secondary">* Default My Wifi</small>
                          <input type="text" class="form-control" placeholder="Nama App" v-model="appnameedit">
                          <label for="" class="bmd-label-floating mt-4">Link App <span class="text-danger">(Opsional, Bila anda sudah berlanggan custom app pelanggan)</span></label>
                          <small text="text-secondary">* Default Link My Wifi</small>
                          <input type="text" class="form-control" placeholder="Link App" v-model="applinkedit">
                        </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-success" @click="modalWAPassword = false,kirimPasswordPelanggan()">Kirim</button>
              </div>
          </div>
        </div>
      </div>

			<!-- MODAL -->
      <div class="modal" tabindex="-1" role="dialog" v-show="modalWABlast">
        <div class="overlay"></div>
        <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Blast Wa</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="modalWABlast = false">
                <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                        <div class="form-group">
                          <label class="bmd-label-floating">Ketikan Teks yang akan di kirim</label>
                          <textarea rows="10" type="text" class="form-control" placeholder="Nama Area..." v-model="wa"></textarea>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-success" @click="modalWABlast = false,testTextToURL()">Kirim</button>
              </div>
          </div>
        </div>
      </div>


			<!-- MODAL -->
      <div class="modal" tabindex="-1" role="dialog" v-show="modalHapus">
          <div class="overlay"></div>
          <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Hapus</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="modalHapus = false">
                  <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="row">
                    <div class="col-md-12">
                      <p class="text-center">{{"Hapus Pelanggan "+nmHapus+" ?"}}</p>
                    </div>
                  </div>
                </div>
								<div class="modal-footer">
									<button type="button" class="btn btn-info" @click="modalHapus = false">Tidak</button>
									<button type="button" class="btn btn-secondary" @click="verifPassModal = true;modalHapus = false">Ya</button>
								</div>
            </div>
        </div>
      </div>

			<!-- MODAL -->
      <div class="modal" tabindex="-1" role="dialog" v-show="verifPassModal"> <!-- hapusUser() -->
          <div class="overlay"></div>
          <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Konfirmasi Password</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="verifPassModal = false">
                  <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <span>Demi Keamanan Konfirmasi password anda</span>
                      </div>
                      <div class="form-group">
                        <label class="bmd-label-floating">Password</label>
                        <input type="password" class="form-control" placeholder="Ketikan Password..." v-model="verifPass">
										  </div>
                    </div>
                  </div>
                </div>
								<div class="modal-footer">
									<button type="button" class="btn btn-info" @click="verifPassModal = false">Batal</button>
									<button type="button" class="btn btn-secondary" @click="verifPassModal = false;verifPassword()">Lanjutkan</button>
								</div>
            </div>
        </div>
      </div>


			<!-- MODAL HAPUS MULTI -->
      <div class="modal" tabindex="-1" role="dialog" v-show="modalHapusMulti">
          <div class="overlay"></div>
          <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Hapus Beberapa Pelanggan</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="modalHapusMulti = false">
                  <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="row">
                    <div class="col-md-12">
                      <p class="text-center">{{"Hapus "+DeleteSelect.length+" Pelanggan ?"}}</p>
                    </div>
                  </div>
                </div>
								<div class="modal-footer">
									<button type="button" class="btn btn-info" @click="modalHapusMulti = false">Tidak</button>
									<button type="button" class="btn btn-secondary" @click="verifFor = 'multi';verifPassModal = true;modalHapusMulti = false">Ya</button>
								</div> 
            </div>
        </div>
    </div>

    
    <!-- MODAL ADMIN -->
    <div class="modal" tabindex="-1" role="dialog" v-show="modalAdmin">
      <div class="overlay"></div>
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Pilih Admin</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="modalAdmin = false">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12" style="height: 400px;overflow:auto">
                <div class="table-responsive">
                  <table class="table">
                    <thead class=" text-info">
                      <th>No.</th>
                      <th>Nama</th>
                      <th>Aksi</th>
                    </thead>
                    <tbody>
                      <tr>
                        <td>0</td>
                        <td>{{ namaQ }}</td>
                        <td>
                          <button class="btn btn-sm btn-primary" @click="cariByAdmin(namaQ)"> Pilih</button>
                        </td>
                      </tr>
                      <tr v-for="(u, index) in admin">
                        <td>{{ index+1 }}</td>
                        <td>{{ u.nama }}</td>
                        <td>
                          <button class="btn btn-sm btn-primary" @click="cariByAdmin(u.nama)"> Pilih</button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL -->
    <div class="modal" tabindex="-1" role="dialog" v-show="modalArea">
      <div class="overlay"></div>
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Pilih Area</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="modalArea = false, areaPilih = '', areaPilihNama = '',pageStat = 999">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-footer">
            <div class="col-md-6">
              <label>Area By :</label>
              <span>{{ areaPilihNama }}</span>
            </div>
            <div class="col-md-6 text-right">
              <button class="btn btn-primary" @click="cariCustom()"> Filter Now</button>
            </div>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12" style="height: 350px; overflow: auto">
                <div class="table-responsive">
                  <table class="table">
                    <thead class=" text-info">
                      <th>No.</th>
                      <th>Nama</th>
                      <th>Jumlah</th>
                      <th>Aksi</th>
                    </thead>
                    <tbody>
                      <tr v-for="(u, index) in area">
                        <td>{{ index+1 }}</td>
                        <td>{{ u.nama }}</td>
                        <td>{{ u.jumlah }}</td>
                        <td>
                          <button class="btn btn-sm btn-primary" @click="pilihArea(u.id,u.nama);"> Pilih</button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    

    <!-- MODAL PAKET -->
    <div class="modal" tabindex="-1" role="dialog" v-show="modalPaket">
      <div class="overlay"></div>
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Pilih Paket</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="modalPaket = false">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12" style="height: 400px;overflow:auto">
                <div class="table-responsive">
                  <table class="table">
                    <thead class=" text-info">
                      <th>No.</th>
                      <th>Nama</th>
                      <th>Tarif</th>
                      <th>Aksi</th>
                    </thead>
                    <tbody>
                      <tr v-for="(u, index) in paket">
                        <td>{{ index+1 }}</td>
                        <td>{{ u.nama }}</td>
                        <td>{{ ribu(u.tarif) }}</td>
                        <td>
                          <button class="btn btn-sm btn-primary" @click="cariByPaket(u.id,u.nama)"> Pilih</button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import vuejsDatepicker from 'vuejs-datepicker'
import moment from 'moment'
import inter from '@/globalFunc/Interface' 
import myGlobal from '@/globalFunc/myGlobal' 
import Loading from '@/globalFunc/Loading' 
import { RedisSession } from '@/globalFunc/redis';

Vue.use(moment)

// EXCEL
import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)

export default {
  name: 'Beranda', 
  components: { 
    vuejsDatepicker,
    moment,
    'Loading': Loading
  },
  sockets: {
    connection: function(){
      console.log('socket connected')
    },
    message: function(val){
      console.log(val)
    },
    sent: function(val) {
      //console.log(val)
      
      if(val == "sukses") {
        this.pesanKirimPause = "Pesan berhasil Dikirim";
        this.modalWAFooter = true;
        this.modalWAPasswordFooter = true;
        this.cekWA = false;
        this.checkedNames = [];
        this.selectWaBlast = false;
      } else if (val == "start") {
        this.pesanKirimPause = "Mulai Mengirim Pesan..";
      } else if (val == "restart") {
        this.pesanKirimPause = "Lanjoet Mengirim Pesan...";
      } else if (val == "pause") {
        this.pesanKirimPause = "Di Pause 15s, biar ga ke blokir akak No WhatsAppnya";
      } else {
        this.pesanKirim = val;
        this.progress = this.progress + 1;
      }
    }
  },
  data () {
    return {
      loading: true,
      pelanggan: [],

      // DELETE SCENE
      isOnDelete: false,
      DeleteSelect: [],
      DeleteIdFix: null,
      modalHapusMulti: false,


      filter: null,

      cariByTelepon: false,
      area: [],
      
      showing: -1,
      telepon: '',
      dariTanggal: '',
      sampaiTanggal: '',
      statuse: '',
      filtered: '',

      // hapus
      idHapus: '',
      nmHapus: '',
      
      // cari kurir
      cariPelanggan: '',
      textCariPelanggan: '',
      textSalah: '',
      idPelanggan: '',
      namaPelanggan: '',

      // topup
      topup: '',
      password: '',

      //
      ppn: '',
      infoShow: -1,

      // modal
      modalHapus: false,
      modalArea:false,

      verifPassModal: false,
      verifPass: '',
      verifFor: null, // is null singel delete, multi = multi deleted


      // modal 
      preCari: true,

      judulDoc: '',
      nameDoc: '',
      json_fieldspelanggan: {
        "No" : 'no',
        'PPOE': 'ppoe',
        'Nama': 'nama',
        'Telepon': 'telepon',
        'Alamat': 'alamat',
        'Paket': 'paket',
        'Area': 'area',
        'Biaya': 'biaya',
        'Tanggal Tagihan': 'tanggal',
        'Rincian Tambahan 1': 'r1',
        'Biaya Tambahan 1': 'b1',
        'Rincian Tambahan 2': 'r2',
        'Biaya Tambahan 2': 'b2',
        'Diskon': 'diskon',
        'PPN': 'ppn',
        'Total Bayar': 'total'
      },
      json_datapelanggan: [],
      json_metapelanggan: [
          [
              {
                  'key': 'charset',
                  'value': 'utf-8'
              }
          ]
      ],

      areaPilih: '',
      areaPilihNama: '',

      modalAdmin: '',
      namaQ: '',
      admin: [],

      modalWABlast: false,
      selectWaBlast: false,
      checkedNames: [],
      wa: '',
      sesi: '',
      modalWA: false,
      modalWAFooter: false,

      pesanKirim: '',
      pesanKirimPause: '',
      progress: 0,
      totalProgress: 0,

      modalWAPassword: false,
      modalWAPasswordProgress: false,
      modalWAPasswordFooter: false,
      xxx: '',
      appname: "My Wifi",
      applink: 'https://play.google.com/store/apps/details?id=com.mywifi.contoh',
      waPass : 'Halo Pak/Bu [[nama]], Yuk Login ke Aplikasi buat Pelanggan *[[rtrw]]* buat liat pembayarannya \n\nTelepon : [[telepon]] \nPassword : [[password]] \n\nDownload di Playstore " [[appnamex]] " ya. \nLink : [[applinkx]] \n\nTerima Kasih',
      waPassDisplay : 'Halo Pak/Bu [[nama]], Yuk Login ke Aplikasi buat Pelanggan *[[rtrw]]* buat liat pembayarannya \n\nTelepon : [[telepon]] \nPassword : [[password]] \n\nDownload di Playstore " [[appnamex]] " ya. \nLink : [[applinkx]] \n\nTerima Kasih',
      appnameedit: '',
      applinkedit: '',
      namaQ: '',
      page: 0,
      pageStat: 0,
      pageLimit: "15",


      totalPelanggan: '',
      prefix: '',

      modalPaket: false,
      paket: [],
      kosongText: '',
      
       
    }
  },
  methods: {
    verifPassword() {
      if (this.verifPass == "") {
        alert("Password tidak boleh kosong");
        return false;
      }

      var data = {
        token: 'TangTung '+sessionStorage.getItem('myToken'),
        password: this.verifPass
      }
      
      var apiUrl = inter.postPassword();
      this.PostData(data,apiUrl).then(x => {
        if (x.status) {
          if (this.verifFor == "multi") {
            this.hapusMultiConfirm();
          } else {
            this.hapusUser();
          }
          this.verifPass = "";
        } else {
          this.verifPass = "";
          alert(x.pesan);
        }
      })
    },
    getPaket() {
      let cacheT = "all_paket"; // REDIS ====================================
      const cached = RedisSession.get(cacheT);
      if (cached) {
          let x = cached;

          // LANJUT DI BAWAH
          if (x.status) {
            this.paket = x.data;
          } else {
            //alert(x.pesan);
          }

          myGlobal.loger("dari radis "+cacheT);

          return false;
      }

      myGlobal.loger("baru "+cacheT);

      this.isCari = false;

      var data = {
        token: 'TangTung '+sessionStorage.getItem('myToken')
      }
      
      var apiUrl = inter.ListPaket();
      this.PostData(data,apiUrl).then(x => {

        RedisSession.set(cacheT, x, 600000); // 10 menit

        if (x.status) {
          this.paket = x.data;
        } else {
          //alert(x.pesan);
        }
      })
    },
    cariByPaket(paket,nama) {
      this.loading = true;
      this.modalPaket = false;

      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('paket', paket);
      data.append('bulan', sessionStorage.getItem('bulanIdBase'));
      data.append('tahun', sessionStorage.getItem('tahunBase'));
      data.append('type', "all");
      data.append('tanggal', "null");
      data.append('by', "paket");
      
      var apiUrl = inter.PelangganListCari();
      this.PostData(data,apiUrl).then(x => {
        this.loading = false;

        if (x.status == true) {
          this.pelanggan = x.data;
        } else {
          this.pelanggan = [],
          this.kosongText = nama
        }
      })
    },
    hapusMultiConfirm() {
      var data = {
        token: 'TangTung '+sessionStorage.getItem('myToken'),
        id: this.DeleteIdFix
      }
      
      var apiUrl = inter.PelangganHapusMulti(); // hapusUser
      this.PostData(data,apiUrl).then(x => {
        //myGlobal.loger(x);

        if (x.status) {

          this.getData();
          this.DeleteSelect = [];
          this.isOnDelete = false;

        } else {
          //alert(x.pesan);
        }

      })
    },
     
    hapusMulti() {
      this.DeleteIdFix = null;
      for (let i = 0; i < this.DeleteSelect.length; i++) {
        if (this.DeleteIdFix == null) {
          this.DeleteIdFix = this.DeleteSelect[i];
        } else {
          this.DeleteIdFix = this.DeleteIdFix + "," + this.DeleteSelect[i];
        }
      }

      this.modalHapusMulti = true;
    },
    pilihSemua() {
      this.checkedNames = [];
      //if (!this.allSelected) {
          for (let i = 0; i < this.pelanggan.length; i++) {
              this.checkedNames.push(this.pelanggan[i].user);
          }
          //console.log(JSON.stringify(this.checkedNames));
      //}
    },
    testTextToURL() {
      if (this.wa == '') {
        alert('Kok kosong teksnya?');
        return;
      }
      var str = this.wa; //.replace(/(?:\r|\n|\r\n)/g, '%0a');
      //str = str.replace(/\s/g, '%20');
            
      if (sessionStorage.getItem('walogin') == 'kosong') {
        alert('Anda belum scan wa');
        return;
      }
      if (sessionStorage.getItem('walogin') == 'belum') {
        alert('Anda belum scan wa');
        return false;
      }
      
      this.progress = 0;

      this.modalWA = true;

      this.totalProgress = this.checkedNames.length;
      
      var theData = {
        data: JSON.stringify({
            data: this.checkedNames,
            pesan: "Bebas sih ini",
            status: true
        }),
        token: this.sesi,
        pesanwa: str,
        //bulan: this.bulanBase+ ' ' + this.tahunBase,
        //namaKu: sessionStorage.getItem('admin'),
        //wateks: sessionStorage.getItem('wateks'),
        //ppn: sessionStorage.getItem('PPN')
      }
      //console.log(JSON.stringify(theData));

      this.$socket.emit('kirim-blast-notemplate', theData);
    },

    kirimPasswordPelanggan() {
      //console.log("kirimPasswordPelanggan()");
      //console.log(this.sesi);

      this.totalProgress = this.checkedNames.length;

      var userid = null;

      for (let i = 0; i < this.totalProgress; i++) {
        if (userid == null) {
          userid = this.checkedNames[i]["uid"];
        } else {
          userid = userid + "," + this.checkedNames[i]["uid"];
        }
      }

      // sukses reset password
      if (this.waPass == '') {
        alert('Kok kosong teksnya?');
        return;
      }
      var str = this.waPass; //.replace(/(?:\r|\n|\r\n)/g, '%0a');
      //str = str.replace(/\s/g, '%20');
            
      if (sessionStorage.getItem('walogin') == 'kosong') {
        alert('Anda belum scan wa');
        return;
      }
      if (sessionStorage.getItem('walogin') == 'belum') {
        alert('Anda belum scan wa');
        return false;
      }

      if (this.appnameedit != '') {
        if (this.applinkedit == "") {
          alert('Link App tidak boleh kosong');
          return;
        }
        
        str = str.replace("[[appnamex]]", this.appnameedit);
        str = str.replace("[[applinkx]]", this.applinkedit);
      } else {
        str = str.replace("[[appnamex]]", this.appname);
        str = str.replace("[[applinkx]]", this.applink);
      }

      str = str.replace("[[rtrw]]", this.namaQ);
      
      this.progress = 0;

      this.modalWAPasswordProgress = true;

      //console.log(JSON.stringify(theData));

      var data = {
        token: 'TangTung '+sessionStorage.getItem('myToken'),
        ids: userid
      }
      
      var apiUrl = inter.PelangganResetPassMulti(); // hapusUser
      this.PostData(data,apiUrl).then(x => {
        if (x.status) {
          //console.log(JSON.stringify(x.data));
          console.log(theData);

          str = str.replace("[[password]]", x.data);

          var theData = {
            data: JSON.stringify({
                data: this.checkedNames,
                pesan: "Bebas sih ini",
                status: true
            }),
            token: this.sesi,
            pesanwa: str,
            //bulan: this.bulanBase+ ' ' + this.tahunBase,
            //namaKu: sessionStorage.getItem('admin'),
            //wateks: sessionStorage.getItem('wateks'),
            //ppn: sessionStorage.getItem('PPN')
          }
          this.$socket.emit('kirim-blast-password', theData);
        } else {
          //alert(x.pesan);
        }
      })

    },

    customFormatter (date) {
        return moment(date).format('YYYY-MM-DD');
    },
    cariTelepon() {
      this.cariByTelepon = true;
    },
    cariTeleponApi() {
      this.loading = true;
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('cari', this.telepon);
      data.append('bulan', "0");
      data.append('tahun', "0");
      data.append('type', "all");
      data.append('by', "nama");
      //data.append('area', null);
      //data.append('tanggal', null);
      //data.append('admin', null); // JIKA NULL GA USAH DIKIRIM
      
      var apiUrl = inter.PelangganListCari();
      this.PostData(data,apiUrl).then(x => {
        // console.log(JSON.stringify(x));
        this.loading = false;
        if (x.status == true) {
          this.pelanggan = x.data;

          var data = x.data;
          var values = [];
          var i;
          for (i = 0; i < data.length; i++) {
              var item1 = {
                  "no" : i+1,
                  'nama' : data[i].user.unama, //this.tglIndo(data[i].due_date) 
                  'telepon': data[i].user.wa,
                  'alamat': data[i].user.alamat,
                  'paket': data[i].user.pnama,
                  'area': data[i].area,
                  'biaya': this.ribu(data[i].user.ptarif),
                  'ppoe': data[i].user.ppoe,
                  'tanggal': data[i].user.tanggal_tagihan,
                  'r1': data[i].user.biaya_rincian,
                  'b1': this.ribu(data[i].user.biaya_tambahan),
                  'r2': data[i].user.biaya_rincian_2,
                  'b2': this.ribu(data[i].user.biaya_tambahan_2),
                  'diskon': this.ribu(data[i].user.diskon), 
                  'ppn': this.ppn+"%", 
                  'total': this.ribu( ( ( parseInt(data[i].user.ptarif) + parseInt(this.isNull(data[i].user.biaya_tambahan)) + parseInt(this.isNull(data[i].user.biaya_tambahan_2)) ) + (  ( (parseInt(data[i].user.ptarif) + parseInt(this.isNull(data[i].user.biaya_tambahan)) + parseInt(this.isNull(data[i].user.biaya_tambahan_2)) ) / 100 ) ) * parseInt(this.ppn)   ) - parseInt(this.isNull(data[i].user.diskon)) )
              };
              values.push(item1);
          }
          this.json_datapelanggan = values;          
          this.judulDoc = ["Pelanggan - "+this.tglIndo(new Date)];
          this.nameDoc = "Pelanggan - "+this.tglIndo(new Date)+".xls";
        } else {
          //alert(x.pesan);
          this.textCariPelanggan = x.pesan;
        }
      })
    },
    isNull(x) {
      var a;
      if (x == null || x == "") {
        a = 0;
      } else {
        a = x
      }
      return a;
    },
    pilihArea(id,nama) {
      this.areaId = id;
      this.areaName = nama;
      //this.modalArea = false;
      //this.modalArea = false;

      if (this.areaPilih != "") {
        if (this.areaPilih.indexOf(id) > -1)
        {
          //alert("hello found inside your_string");
        } else {
          this.areaPilih = this.areaPilih+","+id;
          this.areaPilihNama = this.areaPilihNama+","+nama;
        }
      } else {
        this.areaPilih = id;
        this.areaPilihNama = nama;
      }

      console.log(this.areaPilih);

    },
    showArea() {
      this.modalArea = true;

      this.getArea();
    },
    showPaket() {
      this.modalPaket = true;

      this.getPaket();
    },
    cariCustom() {
      this.loading = true;
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('bulan', "0");
      data.append('type', "all");
      data.append('area', this.areaPilih);
      data.append('by', "area");
      data.append('tahun', myGlobal.getTahunNow());
      if (this.$route.params.filter == "new") {
        data.append('filter', "new");
      }
      
      var apiUrl = inter.PelangganListCari();
      this.PostData(data,apiUrl).then(x => {

        //myGlobal.loger(x)
        
        this.modalArea = false;
        this.areaPilih = "";
        this.areaPilihNama = "";
        this.loading = false;
        if (x.status) {
          this.pelanggan = x.data;
          this.totalBelum = x.pesan;
          
          var data = x.data;
          var values = [];
          var i;
          for (i = 0; i < data.length; i++) {
              var item1 = {
                  "no" : i+1,
                  'nama' : data[i].user.unama, //this.tglIndo(data[i].due_date)
                  'telepon': data[i].user.wa,
                  'alamat': data[i].user.alamat,
                  'paket': data[i].user.pnama,
                  'area': data[i].area,
                  'biaya': this.ribu(data[i].user.ptarif),
                  'ppoe': data[i].user.ppoe,
                  'tanggal': data[i].user.tanggal_tagihan,
                  'r1': data[i].user.biaya_rincian,
                  'b1': this.ribu(data[i].user.biaya_tambahan),
                  'r2': data[i].user.biaya_rincian_2,
                  'b2': this.ribu(data[i].user.biaya_tambahan_2),
                  'diskon': this.ribu(data[i].user.diskon), 
                  'ppn': this.ppn+"%", 
                  'total': this.ribu( ( ( parseInt(data[i].user.ptarif) + parseInt(this.isNull(data[i].user.biaya_tambahan)) + parseInt(this.isNull(data[i].user.biaya_tambahan_2)) ) + (  ( (parseInt(data[i].user.ptarif) + parseInt(this.isNull(data[i].user.biaya_tambahan)) + parseInt(this.isNull(data[i].user.biaya_tambahan_2)) ) / 100 ) ) * parseInt(this.ppn)   ) - parseInt(this.isNull(data[i].user.diskon)) )
              };
              values.push(item1);
          }
          this.json_datapelanggan = values;          
          this.judulDoc = ["Pelanggan - "+this.tglIndo(new Date)];
          this.nameDoc = "Pelanggan "+this.areaName+" - "+this.tglIndo(new Date)+".xls";
        } else {
          //alert(x.pesan);
          this.pelanggan = null;
          this.textCariPelanggan = x.pesan;
        }
      })
    },
    hapusUser() {
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('id', this.idHapus);
      
      var apiUrl = inter.PelangganHapus(); // hapusUser
      this.PostData(data,apiUrl).then(x => {
        if (x.status) {
          this.getData();
          this.showing = -1;
        } else {
          //alert(x.pesan);
        }
      })

    },
    startDownload() {

    },
    getArea() {
      let cacheT = "all_area"; // REDIS ====================================
      const cached = RedisSession.get(cacheT);
      if (cached) {
          let x = cached;

          // LANJUT DI BAWAH
          if (x.status) {
            this.area = x.data;

          }

          myGlobal.loger("dari radis "+cacheT);

          return false;
      }
      myGlobal.loger("baru "+cacheT);

      // for filter
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('type', "all");
      data.append('bulan', sessionStorage.getItem('bulanIdBase'));
      
      var apiUrl = inter.ListArea();
      this.PostData(data,apiUrl).then(x => {
        
        RedisSession.set(cacheT, x, 600000); // 10 menit

        if (x.status) {
          this.area = x.data;

        } else {
          //alert(x.pesan);
        }
      })
    },
    getData() {

      /*
      // CEK POLIND DULU
      
      if (this.filter != "new") { // this.filter = this.$route.params.filter
        
        let polling = JSON.parse(sessionStorage.getItem("main-old_getData"));
        
        if(polling != null) {
          let time = polling.time;
          let d = polling.d;

          this.page = polling.page;

          let sudah5menit = myGlobal.cek5menit(time);
          if(sudah5menit == "belum") {
            this.loading = false;
            console.log("BELUM 5 MENITTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTT");
            
              this.pelanggan = d;

              //let sementara = JSON.stringify(this.pelanggan);
              //sessionStorage.setItem("pelangganSementara", sementara);

              var data = d;
              var values = [];
              var i;
              
              for (i = 0; i < data.length; i++) {
            
                  var telepon = data[i].user.wa;
                  if (telepon.charAt(0) == "0") {
                    telepon = "62"+telepon.substring(1);
                  } else if (telepon.charAt(0) == "8") {
                    telepon = "62"+telepon;
                  }

                  var item1 = {
                      "no" : i+1,
                      'nama' : data[i].user.unama, //this.tglIndo(data[i].due_date)
                      'telepon': telepon,
                      'alamat': data[i].user.alamat,
                      'paket': data[i].user.pnama,
                      'area': data[i].area,
                      'biaya': this.ribu(data[i].user.ptarif),
                      'ppoe': data[i].user.ppoe,
                      'tanggal': data[i].user.tanggal_tagihan,
                      'r1': data[i].user.biaya_rincian,
                      'b1': this.ribu(data[i].user.biaya_tambahan),
                      'r2': data[i].user.biaya_rincian_2,
                      'b2': this.ribu(data[i].user.biaya_tambahan_2),
                      'diskon': this.ribu(data[i].user.diskon), 
                      'ppn': this.ppn+"%", 
                      'total': this.ribu( ( ( parseInt(data[i].user.ptarif) + parseInt(this.isNull(data[i].user.biaya_tambahan)) + parseInt(this.isNull(data[i].user.biaya_tambahan_2)) ) + (  ( (parseInt(data[i].user.ptarif) + parseInt(this.isNull(data[i].user.biaya_tambahan)) + parseInt(this.isNull(data[i].user.biaya_tambahan_2)) ) / 100 ) ) * parseInt(this.ppn)   ) - parseInt(this.isNull(data[i].user.diskon)) )
                  };
                  values.push(item1);
              }
              this.json_datapelanggan = values;          
              this.judulDoc = ["Pelanggan - "+this.tglIndo(new Date)];
              this.nameDoc = "Pelanggan - "+this.tglIndo(new Date)+".xls";


            return false;
          }
          
        }
        
      }

      console.log("Ambil Baru");

      */

      // AMBIL DATA DARI PENYIMPANAN SEMENTARA

      /*
      let pelSementaralokal = sessionStorage.getItem("pelangganSementara");

      if(pelSementaralokal != null) {
        this.loading = false;

        this.pelanggan = JSON.parse(pelSementaralokal);

        // alert("sementara");

        return false
      }
        */

      let bulan = sessionStorage.getItem('bulanIdBase');
      let tahun = sessionStorage.getItem('tahunBase');

      let cacheT = "pel_all-"+bulan+"-"+tahun+"-page0"; // REDIS ====================================

      /// console.log(cacheT);

      if (this.filter == "new") { // this.filter = this.$route.params.filter
        cacheT = "pel_all-"+bulan+"-"+tahun+"-page0-new"; // REDIS ====================================
      }

      const cached = RedisSession.get(cacheT);
      if (cached) {
          let x = cached;

          // LANJUT DI BAWAH
          this.pelanggan = x.data;

          myGlobal.loger("dari radis "+cacheT);
          
          this.loading = false;

          return false;
      }
      myGlobal.loger("baru "+cacheT);

      this.isCari = false;
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('type', "all");
      data.append('bulan', bulan);
      data.append('page', this.page);
      data.append('tahun', tahun);
      data.append('limit', this.pageLimit);

      if (this.$route.params.filter == "new") { // this.filter = this.$route.params.filter
        data.append('filter', "new");
      } 
      
      var apiUrl = inter.PelangganList();
      this.PostData(data,apiUrl).then(x => {
        //console.log(JSON.stringify(x))
          
        RedisSession.set(cacheT, x, 300000); // 5 menit
        
        this.loading = false;
        if (x.status) {
          
          this.pelanggan = x.data;

          //let sementara = JSON.stringify(this.pelanggan);
          //sessionStorage.setItem("pelangganSementara", sementara);
          
          /*
          var data = x.data;
          var values = [];
          var i;
          
          for (i = 0; i < data.length; i++) {
        
              var telepon = data[i].user.wa;
              if (telepon.charAt(0) == "0") {
                telepon = "62"+telepon.substring(1);
              } else if (telepon.charAt(0) == "8") {
                telepon = "62"+telepon;
              }

              var item1 = {
                  "no" : i+1,
                  'nama' : data[i].user.unama, //this.tglIndo(data[i].due_date)
                  'telepon': telepon,
                  'alamat': data[i].user.alamat,
                  'paket': data[i].user.pnama,
                  'area': data[i].area,
                  'biaya': this.ribu(data[i].user.ptarif),
                  'ppoe': data[i].user.ppoe,
                  'tanggal': data[i].user.tanggal_tagihan,
                  'r1': data[i].user.biaya_rincian,
                  'b1': this.ribu(data[i].user.biaya_tambahan),
                  'r2': data[i].user.biaya_rincian_2,
                  'b2': this.ribu(data[i].user.biaya_tambahan_2),
                  'diskon': this.ribu(data[i].user.diskon), 
                  'ppn': this.ppn+"%", 
                  'total': this.ribu( ( ( parseInt(data[i].user.ptarif) + parseInt(this.isNull(data[i].user.biaya_tambahan)) + parseInt(this.isNull(data[i].user.biaya_tambahan_2)) ) + (  ( (parseInt(data[i].user.ptarif) + parseInt(this.isNull(data[i].user.biaya_tambahan)) + parseInt(this.isNull(data[i].user.biaya_tambahan_2)) ) / 100 ) ) * parseInt(this.ppn)   ) - parseInt(this.isNull(data[i].user.diskon)) )
              };
              values.push(item1);
          }
          this.json_datapelanggan = values;          
          this.judulDoc = ["Pelanggan - "+this.tglIndo(new Date)];
          this.nameDoc = "Pelanggan - "+this.tglIndo(new Date)+".xls";

          */



        } else {
          //alert(x.pesan);
        }
      })
    },
    loadAll() {
      return false;

      this.isCari = false;
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('type', "all");
      data.append('bulan', sessionStorage.getItem('bulanIdBase'));
      data.append('page', "all");
      data.append('tahun', sessionStorage.getItem('tahunBase'));
      if (this.$route.params.filter == "new") {
        data.append('filter', "new");

        console.log("ini pelanggan baru");
      }

      //alert(this.$route.params.filter);
      
      var apiUrl = inter.PelangganList();
      this.PostData(data,apiUrl).then(x => {

        this.loading = false;
        if (x.status) {
          this.pelanggan = x.data;

          var data = x.data;
          var values = [];
          var i;
          
          for (i = 0; i < data.length; i++) {
            var telepon = data[i].user.wa;
            if (telepon.charAt(0) == "0") {
              telepon = "62"+telepon.substring(1);
            } else if (telepon.charAt(0) == "8") {
              telepon = "62"+telepon;
            }

            var item1 = {
                "no" : i+1,
                'nama' : data[i].user.unama, //this.tglIndo(data[i].due_date)
                'telepon': telepon,
                  'alamat': data[i].user.alamat,
                'paket': data[i].user.pnama,
                'area': data[i].area,
                'biaya': this.ribu(data[i].user.ptarif),
                'ppoe': data[i].user.ppoe,
                'tanggal': data[i].user.tanggal_tagihan,
                'r1': data[i].user.biaya_rincian,
                'b1': this.ribu(data[i].user.biaya_tambahan),
                'r2': data[i].user.biaya_rincian_2,
                'b2': this.ribu(data[i].user.biaya_tambahan_2),
                'diskon': this.ribu(data[i].user.diskon), 
                'ppn': this.ppn+"%", 
                'total': this.ribu( ( ( parseInt(data[i].user.ptarif) + parseInt(this.isNull(data[i].user.biaya_tambahan)) + parseInt(this.isNull(data[i].user.biaya_tambahan_2)) ) + (  ( (parseInt(data[i].user.ptarif) + parseInt(this.isNull(data[i].user.biaya_tambahan)) + parseInt(this.isNull(data[i].user.biaya_tambahan_2)) ) / 100 ) ) * parseInt(this.ppn)   ) - parseInt(this.isNull(data[i].user.diskon)) )
            };
            values.push(item1);
          }
          this.json_datapelanggan = values;          
          this.judulDoc = ["Pelanggan - "+this.tglIndo(new Date)];
          this.nameDoc = "Pelanggan - "+this.tglIndo(new Date)+".xls";

        } else {
          //alert(x.pesan);
          this.pageStat = 999;
        }
      })
    },
    loadMore() {
      this.page = this.page + 1;

      //console.log(this.tglIndo(new Date));
      this.isCari = false;
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('type', "all");
      data.append('bulan', sessionStorage.getItem('bulanIdBase'));
      data.append('page', this.page);
      data.append('tahun', sessionStorage.getItem('tahunBase'));
      data.append('limit', this.pageLimit);

      if (this.$route.params.filter == "new") {
        data.append('filter', "new");

        console.log("ini pelanggan baru");
      }

      //alert(this.$route.params.filter);
      
      var apiUrl = inter.PelangganList();
      this.PostData(data,apiUrl).then(x => {

        this.loading = false;
        if (x.status) {
          //this.pelanggan = x.data;

          var data = x.data;

          var values = [];
          var i;
          
          for (i = 0; i < data.length; i++) {
        
            var telepon = data[i].user.wa;
            if (telepon.charAt(0) == "0") {
              telepon = "62"+telepon.substring(1);
            } else if (telepon.charAt(0) == "8") {
              telepon = "62"+telepon;
            }
            
            var item1 = {
                "no" : i+1,
                'nama' : data[i].user.unama, //this.tglIndo(data[i].due_date)
                'telepon': telepon,
                'paket': data[i].user.pnama,
                'area': data[i].area,
                'biaya': this.ribu(data[i].user.ptarif),
                'ppoe': data[i].user.ppoe,
                'tanggal': data[i].user.tanggal_tagihan,
                'r1': data[i].user.biaya_rincian,
                'b1': this.ribu(data[i].user.biaya_tambahan),
                'r2': data[i].user.biaya_rincian_2,
                'b2': this.ribu(data[i].user.biaya_tambahan_2),
                'diskon': this.ribu(data[i].user.diskon), 
                'ppn': this.ppn+"%", 
                'total': this.ribu( ( ( parseInt(data[i].user.ptarif) + parseInt(this.isNull(data[i].user.biaya_tambahan)) + parseInt(this.isNull(data[i].user.biaya_tambahan_2)) ) + (  ( (parseInt(data[i].user.ptarif) + parseInt(this.isNull(data[i].user.biaya_tambahan)) + parseInt(this.isNull(data[i].user.biaya_tambahan_2)) ) / 100 ) ) * parseInt(this.ppn)   ) - parseInt(this.isNull(data[i].user.diskon)) )
            };
            values.push(item1);
            
            this.pelanggan.push(data[i]);
          }

          this.json_datapelanggan = values;          
          this.judulDoc = ["Pelanggan - "+this.tglIndo(new Date)];
          this.nameDoc = "Pelanggan - "+this.tglIndo(new Date)+".xls";
          
          //let sementara = JSON.stringify(this.pelanggan);
          //sessionStorage.setItem("pelangganSementara", sementara);
          
          
          // PASANG DATA BARU
          let waktu = myGlobal.timeNow();
          let polling = {
            time: waktu,
            d: this.pelanggan,
            page: this.page
          }
          sessionStorage.setItem("main-old_getData", JSON.stringify(polling));

        } else {
          //alert(x.pesan);
          this.pageStat = 999;
        }
      })
    },
    getSesi() {
      /*
      var datax = {
        token: 'TangTung '+sessionStorage.getItem('myToken')
      };
  
      var apiUrl = inter.GetSesi();
      myGlobal.call(datax,apiUrl).then(x => {
        //console.log(JSON.stringify(x));
        if (x.status == true) {
          //this.data.List = x.data;
          this.sesi = x.data;

        } else {
          //alert(x.pesan);
        }
      })
      */
    }
  },
  mounted () {
    document.title = "List Pelanggan";

    this.filter = this.$route.params.filter;

    //console.log(this.filter);

    this.ppn = myGlobal.PPN();

    let prefix = sessionStorage.getItem('prefix');
    if (prefix != null) {
      this.prefix = prefix;
    } else {
      this.prefix = "#";
    }

    this.getData();
    //this.getSesi();

    /*
    NAME REPLACE
    */
    this.namaQ = sessionStorage.getItem('admin');
    
    this.waPassDisplay = this.waPassDisplay.replace("[[appnamex]]", this.appname);
    this.waPassDisplay = this.waPassDisplay.replace("[[appnamex]]", this.appname);
    this.waPassDisplay = this.waPassDisplay.replace("[[applinkx]]", this.applink);
    this.waPassDisplay = this.waPassDisplay.replace("[[rtrw]]", this.namaQ);

    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.modal {
	display: inherit;
}
.tombol {
  cursor: pointer;
}
.info {
  position: absolute;
  background-color: #fff;
  border: 1px solid #eee;
  border-radius: 5px;
  padding: 10px;
  z-index: 999999999;
  margin-top: -50px;
}
</style>



// WEBPACK FOOTER //
// src/components/pelanggan/main-old.vue